module.exports = __webpack_public_path__ + "img/Dwerve-Slice-Tower-532.e387ab07.gif";